const POLISH_MONTHS = [
  "Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec",
  "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień",
];

export function formatPLN(value: number | string): string {
  const n = typeof value === "string" ? parseFloat(value) : value;
  const fixed = n.toFixed(2).replace(".", ",");
  // Insert thin space as thousands separator on the integer part.
  const [intPart, frac] = fixed.split(",");
  const sign = intPart.startsWith("-") ? "-" : "";
  const absInt = sign ? intPart.slice(1) : intPart;
  const grouped = absInt.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${sign}${grouped},${frac} PLN`;
}

export function parsePeriodId(periodId: string): { year: number; month: number } {
  const [y, m] = periodId.split("-").map(Number);
  return { year: y, month: m };
}

export function formatPeriod(periodId: string): string {
  const { year, month } = parsePeriodId(periodId);
  return `${POLISH_MONTHS[month - 1]} ${year}`;
}

export function addMonths(periodId: string, delta: number): string {
  const { year, month } = parsePeriodId(periodId);
  const totalMonths = year * 12 + (month - 1) + delta;
  const newYear = Math.floor(totalMonths / 12);
  const newMonth = (totalMonths % 12) + 1;
  return `${newYear.toString().padStart(4, "0")}-${newMonth.toString().padStart(2, "0")}`;
}

export function periodIdFromDate(d: Date): string {
  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  return `${y}-${m.toString().padStart(2, "0")}`;
}
